import React from 'react';

const NotificationItem = ({ notification, onMarkAsRead, onDelete }) => {
    const handleItemClick = () => {
        if (!notification.read && onMarkAsRead) {
            onMarkAsRead(notification.id);
        }
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation(); // Prevent triggering onMarkAsRead when deleting
        if (onDelete) {
            onDelete(notification.id);
        }
    };

    return (
        <div
            className={`list-group-item d-flex justify-content-between align-items-center p-2 ${!notification.read ? 'notification-unread' : ''}`}
            onClick={handleItemClick}
            style={{ cursor: !notification.read ? 'pointer' : 'default' }}
        >
            <div className="text-start">
                <span>{notification.title}</span>
                <p className='mt-2'>{notification.message}</p>
                <small className="text-muted d-block notification-date">
                    <i className="bi bi-calendar-event me-1"></i>{notification.time}
                </small>
            </div>
            <button className="btn btn-link text-danger p-0 notification-delete-btn" type="button" title="Eliminar notificación" aria-label="Eliminar notificación" onClick={handleDeleteClick}>
                <i className="bi bi-trash"></i>
            </button>
        </div>
    );
};

export default NotificationItem;